import React, { useRef } from "react";
import { withRouter } from "react-router";
import IframeResizer from "iframe-resizer-react";
import { useState, useEffect } from "react";

import "./index.scss";

const Iframe = ({ url }) => {
  const size = useWindowSize();
  const iframeRef = useRef();
  const [iframeOffsetX, setIframeOffsetX] = useState(0);
  const [iframeOffsetY, setIframeOffsetY] = useState(0);

  useEffect(() => {
    if (iframeRef.current) {
      const offsets = iframeRef.current.getBoundingClientRect();
      setIframeOffsetX(offsets.x);
      setIframeOffsetY(offsets.y + 40);
    }
  }, []);

  let divWidth = size.width - iframeOffsetX - 25;
  let divMarginBottom = 0;
  if (size.width >= 768) {
    divMarginBottom = 40;
  }

  const getIframeUrl = (_url) => {
    if (_url) {
      return _url;
    }
    return '';
  }

  return (
    <div
      ref={iframeRef}
      style={{
        overflow: "auto",
        width: divWidth,
        marginBottom: divMarginBottom,
      }}
    >
      <IframeResizer
        src={`${process.env.REACT_APP_TROCAR_APP_URL}/application/${getIframeUrl(url)}`}
        sizeWidth={true}
        key={url}
        sizeHeight
        minHeight={size.height - iframeOffsetY}
        style={{
          minWidth: divWidth,
        }}
        frameBorder="0"
      />
    </div>
  );
};

function useWindowSize() {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
  });

  return windowSize;
}

export default withRouter(Iframe);
